import { BrowserModule } from '@angular/platform-browser';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';


import { AppComponent } from './app.component';
import { JoinFormComponent } from './pages/join-form/join-form.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { VouchersComponent } from './pages/vouchers/vouchers.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';

// modules
import { NgbModule, NgbDateParserFormatter, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './/app-routing.module';
import { SwiperModule } from 'ngx-useful-swiper';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AgmCoreModule } from '@agm/core';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgSelectModule } from '@ng-select/ng-select';

// components
import { FormPageComponent } from './components/form-page/form-page.component';
import { FooterComponent } from './components/footer/footer.component'; 
import { InputFieldComponent } from './components/input-field/input-field.component';
import { SelectFieldComponent } from './components/select-field/select-field.component';
import { CheckFieldComponent } from './components/check-field/check-field.component';
import { MultiCheckComponent } from './components/multi-check/multi-check.component';
import { GoogleMapAutofillComponent } from './components/google-map-autofill/google-map-autofill.component';

// service
import { VoucherServiceService } from './voucher-service.service';
import { StripServiceService } from './services/strip-service.service';
import { VenueServiceeService } from './services/venue-service/venue-servicee.service';
import { JoinServiceService } from './services/join-service.service';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { NgDatePickerCustomFormatterService } from './services/ng-date-picker-custom-formatter.service';



@NgModule({
  declarations: [
    AppComponent,
    JoinFormComponent,
    DashboardComponent,
    FooterComponent,
    FormPageComponent,
    InputFieldComponent,
    SelectFieldComponent,
    CheckFieldComponent,
    MultiCheckComponent,
    VouchersComponent,
    NotFoundComponent,
    GoogleMapAutofillComponent,
    DatePickerComponent
  ],
  imports: [
    BrowserModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    NgbModule.forRoot(),
    AppRoutingModule,
    SwiperModule,
    HttpClientModule,
    Ng4LoadingSpinnerModule.forRoot(),
    LazyLoadImageModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    AgmCoreModule.forRoot({
      // apiKey: 'AIzaSyAv7I9_yX8d8IUalCJIti9c08w7wB0eI_8',
       apiKey: 'AIzaSyCb9hzXa-VUDtWjx1RKGhagARN-sO9pv20',
      libraries: ["places"]
    }),
    CurrencyMaskModule
  ],
  providers: [
    VoucherServiceService,
    StripServiceService,
    VenueServiceeService,
    JoinServiceService,
    {provide: NgbDateParserFormatter, useValue: new NgDatePickerCustomFormatterService('DD-MM-YYYY')},
    NgbActiveModal
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
